<div class="dropdown">
    <button type="button" id="member-search-filter-dropdown" class="btn btn-ms-secondary dropdown-toggle"
        data-bs-auto-close="outside" data-bs-toggle="dropdown" aria-expanded="false">
        <fa-duotone-icon icon="filter" secondaryOpacity="0.6" class="fs-6 d-none d-sm-inline" />
        Filter
        @if (filterCount > 0) {
        <span
            class="position-absolute top-0 start-0 translate-middle badge border rounded-circle filter-count">{{filterCount}}</span>
        }
    </button>

    <!--begin::Menu 1-->
    <div ms-parent-focus [alwaysFocusOnRemoval]="true" class="dropdown-menu" (keyup.control.enter)="onApply()"
        role="menu" data-popper-placement="bottom-end">

        <!--begin::Header-->
        <div class="fs-5 fw-bold px-3 py-2">Filter Options</div>
        <!--end::Header-->

        <!--begin::Separator-->
        <div class="separator border-gray-200"></div>
        <!--end::Separator-->

        <!--begin::Content-->

        <!-- First Name Input with Add Button -->
        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">First Name:</label>
            <div class="input-group">
                <input type="text" class="form-control form-control-solid" placeholder="Enter first name"
                    [(ngModel)]="firstNameInput" (keyup.enter)="addFirstName()" />
                <button class="btn btn-primary px-3" type="button" (click)="addFirstName()">
                    <fa-duotone-icon icon="plus" secondaryOpacity="0.9" />
                </button>
            </div>
            <div class="d-flex flex-wrap w-100">
                <!-- Display added first names -->
                @if (activeFilter.firstNames && activeFilter.firstNames.length >
                0) {
                <div class="mt-2">
                    @for (firstName of activeFilter.firstNames; track $index) {
                    <button class="tag-filter btn btn-primary" type="button"
                        (click)="removeFirstName($index)">{{firstName}}
                        <fa-duotone-icon icon="minus" secondaryOpacity="0.9" />
                    </button>
                    }
                </div>
                }
            </div>
        </div>

        <!-- Last Name Input with Add Button -->
        <div class="mb-2 px-3 py-2">
            <label class="form-label fw-semibold">Last Name:</label>
            <div class="input-group">
                <input type="text" class="form-control form-control-solid" placeholder="Enter last name"
                    [(ngModel)]="lastNameInput" (keyup.enter)="addLastName()" />
                <button class="btn btn-primary px-3" type="button" (click)="addLastName()">
                    <fa-duotone-icon icon="plus" secondaryOpacity="0.9" />
                </button>
            </div>
            <!-- Display added last names -->
            @if (activeFilter.lastNames && activeFilter.lastNames.length > 0) {
            <div class="mt-2">
                @for (lastName of activeFilter.lastNames; track $index) {
                <button class="tag-filter btn btn-primary" type="button" (click)="removeLastName($index)">{{lastName}}
                    <fa-duotone-icon icon="minus" secondaryOpacity="0.9" />
                </button>
                }
            </div>
            }
        </div>

        <!-- Email Input with Add Button -->
        <div class="mb-2 px-3 py-2">
            <label class="form-label fw-semibold">Email Address:</label>
            <div class="input-group">
                <input type="email" class="form-control form-control-solid" placeholder="Enter email address"
                    [(ngModel)]="emailInput" (keyup.enter)="addEmail()" />
                <button class="btn btn-primary px-3" type="button" (click)="addEmail()">
                    <fa-duotone-icon icon="plus" secondaryOpacity="0.9" />
                </button>
            </div>
            <!-- Display added emails -->
            @if (activeFilter.emailAddresses &&
            activeFilter.emailAddresses.length > 0) {
            <div class="mt-2">
                @for (email of activeFilter.emailAddresses; track $index) {
                <button class="tag-filter btn btn-primary" type="button" (click)="removeEmail($index)">{{email}}
                    <fa-duotone-icon icon="minus" secondaryOpacity="0.9" />
                </button>
                }
            </div>
            }
        </div>

        <div class="mb-2 px-3 py-2">
            <label class="form-label fw-semibold">Phone Number:</label>
            <div class="input-group">
                <input type="tel" class="form-control form-control-solid" placeholder="Enter phone number"
                    [(ngModel)]="phoneInput" (keyup.enter)="addPhoneNumber()" />
                <button class="btn btn-primary px-3" type="button" (click)="addPhoneNumber()">
                    <fa-duotone-icon icon="plus" secondaryOpacity="0.9" />
                </button>
            </div>
            <!-- Display added phone numbers -->
            @if (activeFilter.phoneNumbers && activeFilter.phoneNumbers.length >
            0) {
            <div class="mt-2">
                @for (phone of activeFilter.phoneNumbers; track $index) {
                <button class="tag-filter btn btn-primary" type="button" (click)="removePhoneNumber($index)">{{phone}}
                    <fa-duotone-icon icon="minus" secondaryOpacity="0.9" />
                </button>
                }
            </div>
            }
        </div>

        <!--begin::Multi-select Input group-->
        <div class="mb-2 px-3 py-2">
            <label class="form-label fw-semibold">Status:</label>
            <ms-multi-select
                placeholder="Select Status"
                [options]="selectMemberStatusOptions"
                [(selectedOptions)]="selectedMemberStatusOptions"
                (selectionChange)="onStatusChange($event)"
            />
        </div>
        <!--end::Multi-select Input group-->

        <!--begin::Role Multi-select Input group-->
        <div class="mb-2 px-3 py-2">
            <label class="form-label fw-semibold">{{ MultiSelectLabelText.Role }}</label>
            <ms-multi-select
                placeholder="Select Role"
                [options]="selectRoleOptions"
                [(selectedOptions)]="selectedRoleOptions"
                (selectionChange)="onRoleChange($event)"
            />
        </div>
        <!--end::Role Multi-select Input group-->

        <!--begin::Actions-->
        <div class="d-flex justify-content-end px-3 py-2">
            <button type="reset" class="btn btn-ms-secondary reset-filter-button me-2 px-6"
                (click)="onReset()">Reset</button>
            <button type="submit" class="btn btn-primary px-6" (click)="onApply()">Apply</button>
        </div>
        <!--end::Actions-->

        <!--end::Content-->
    </div>
    <!--end::Menu 1-->
</div>